module.exports = __webpack_public_path__ + "static/media/ill_coming_soon_no_shadow.16105788.svg";